<template>
  <v-app>
    <header class="header">
      <div class="container">
        <div class="row">
          <div class="col-8">
            <a class="header__logo" href="/" title="Homepage"
              ><img src="./assets/img/logo.svg" alt="Logo" /><span
                >Quality Control</span
              ></a
            >
          </div>
          <div class="col-4 text-right">
            <div class="" v-if="user.email">
              <span class="header__account">{{ user.email }}</span>
              <button class="btn btn--blue-dark" @click.prevent="logout">
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main>
      <router-view />
    </main>
  </v-app>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "App",

  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    init() {
      return this.$store.getters["auth/init"];
    }
  },
  methods: {
    async logout() {
      try {
        await firebase.auth().signOut();
        this.$router.push({ name: "Login" });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
